import { FinanceQuotesResponse } from 'src/types/CataloguePage.types';

import { carmaCsrAuthClient } from 'src/services/instance/carmaCsrAuthClient';
import {
  ExtendedCoverageFinancePayload,
  ExtendedCoverageFinanceResponse,
  FinanceQuote,
  FinanceQuoteRequestPayload,
  FinanceQuoteRequestResponse,
  FinanceQuoteResponse,
} from './FinanceApi.types';

export const getQuoteRequest = (id: string): Promise<FinanceQuoteRequestPayload | null> =>
  carmaCsrAuthClient
    .get<FinanceQuoteRequestPayload[]>(`me/finance/quote-requests/${id}`)
    .json()
    .then((result) => (result.length ? result[0] : null));

export const getQuotes = (id: string): Promise<FinanceQuoteResponse> =>
  carmaCsrAuthClient.get<FinanceQuoteResponse>(`me/finance/quote-requests/${id}/quotes`).json();

/**
 * Request a quote
 */
export const requestQuote = (payload: FinanceQuoteRequestPayload): Promise<FinanceQuoteRequestResponse> =>
  carmaCsrAuthClient.post<FinanceQuoteRequestPayload>(`me/finance/quote-requests`, { json: payload }).json();

export const confirmQuote = (quoteRequestId: string, quoteId: string[]): Promise<FinanceQuote[]> =>
  carmaCsrAuthClient
    .post<FinanceQuote[]>(`me/finance/quote-requests/${quoteRequestId}/quotes/confirm`, { json: quoteId })
    .json();

export const requestPreApprovalCall = (quoteId: string) =>
  carmaCsrAuthClient.post<FinanceQuotesResponse>(`me/finance/quotes/${quoteId}/pre-approval`, {}).json();

export const requestYOUxQuote = (quoteRequestId: string) =>
  carmaCsrAuthClient.post<any>(`me/finance/quote-requests/${quoteRequestId}/foreign-resident`).json();

export const requestQuoteWithNewExtendedCoverage = (payload: ExtendedCoverageFinancePayload) =>
  carmaCsrAuthClient.post<ExtendedCoverageFinanceResponse>(`finance/calculate`, { json: payload }).json();
